<div class="input-group">
  <input
    (keyup.enter)="onButtonClick()"
    onkeydown="return ['Backspace','Delete','ArrowLeft','ArrowRight'].includes(event.code)
    || (!isNaN(Number(event.key)) && event.code !== 'Space')
    || (event.ctrlKey && event.key.toLowerCase() === 'v');"
    [value]="inputValue"
    (input)="onTextChange($event)"
    [type]="Fieldtype"
    [placeholder]="placeholder"
    class="form-control input-form"
  >
  <button
    class="botao-output-emit"
    (click)="onButtonClick()"
    [disabled]="buttonDisabled"
    [style]="{ 'background-color': corBotao , 'color': corTextoBotao }"
  >
    {{ buttonText }}
  </button>
</div>
